const thousandSeparator = (num) => {
    if (num === undefined) return 0
    if (num === null) return 0
    if (num === '') return 0
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export default thousandSeparator